export default "__VITE_ASSET__CslISISL__"